import { render, staticRenderFns } from "./server-button.vue?vue&type=template&id=0a2dd310&scoped=true&"
import script from "./server-button.vue?vue&type=script&lang=js&"
export * from "./server-button.vue?vue&type=script&lang=js&"
import style0 from "./server-button.vue?vue&type=style&index=0&id=0a2dd310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2dd310",
  null
  
)

export default component.exports